import React, { useState, useEffect } from 'react';
import {
    Typography,
    Paper,
    Checkbox,
    FormControlLabel,
    Divider,
    Grid,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import ConfiguracionItems from './ConfiguracionItems';
import { updateEventObject } from '../../../../data-store/actions/events-actions';
import BatchKitDelivery from './BatchKitDelivery';

const ConfiguracionEntregaKits = () => {
    const dispatch = useDispatch();
    const eventParticipants = useSelector(
        (state) => state.registry.eventParticipants
    );
    const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
    const userID = useSelector((state) => state.atlete.userID);

    const registryConfiguration = useSelector(
        (state) => state.registry.registryConfiguration
    );
    const eventDetail = useSelector((state) => state.events.eventDetail);
    const grupoFormularios = registryConfiguration.gruposFormularios;

    const [camposSeleccionados, setCamposSeleccionados] = useState([]);

    const items = registryConfiguration?.configuracion?.entregaKits?.items || {};

    useEffect(() => {
        const iniciales =
            registryConfiguration?.configuracion?.entregaKits?.extraData || [];
        setCamposSeleccionados(iniciales);
    }, [registryConfiguration]);

    const obtenerCamposConID = (grupoFormularios) => {
        if (!grupoFormularios) return [];

        const camposUnicos = {};
        Object.values(grupoFormularios).forEach((grupo) => {
            grupo.forEach((campo) => {
                if (campo.iDCampo && !camposUnicos[campo.iDCampo]) {
                    camposUnicos[campo.iDCampo] = campo;
                }
            });
        });

        return Object.values(camposUnicos);
    };

    const toggleCampo = (idCampo) => {
        const nuevaLista = camposSeleccionados.includes(idCampo)
            ? camposSeleccionados.filter((id) => id !== idCampo)
            : [...camposSeleccionados, idCampo];

        setCamposSeleccionados(nuevaLista);

        dispatch(
            updateEventObject(
                'evento_' + eventDetail.iDEvento,
                'inscripcionesConfiguracion/configuracion/entregaKits/extraData',
                nuevaLista
            )
        );
    };

    return (
        <Paper style={{ padding: 24, marginTop: 16 }}>
            <Typography variant="h4" gutterBottom>
                Configuración de Entrega de Kits
            </Typography>

            <Divider style={{ margin: '16px 0' }} />

            <ConfiguracionItems
                itemsActuales={items}
                eventDetail={eventDetail}
            />

            <Divider style={{ margin: '24px 0' }} />

            <Typography variant="h5" gutterBottom>
                Campos adicionales a mostrar en el detalle del atleta:
            </Typography>

            <Grid container spacing={1}>
                {grupoFormularios &&
                    obtenerCamposConID(grupoFormularios).map((campo) => (
                        <Grid item xs={12} sm={6} md={4} key={campo.iDCampo}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={camposSeleccionados.includes(campo.iDCampo)}
                                        onChange={() => toggleCampo(campo.iDCampo)}
                                        color="primary"
                                    />
                                }
                                label={campo.etiqueta}
                            />
                        </Grid>
                    ))}
            </Grid>

            {/* <BatchKitDelivery eventPath={"eventosCompletos/evento_" + eventDetail.iDEvento} participants={eventParticipants} atleteAccount={atleteAccount} userID={userID} />} */}
        </Paper>
    );
};

export default ConfiguracionEntregaKits;
